/**
 * 换行标签模式（传给 options.lineBreakMode）
 * @readonly
 */
const ADD_BR_LINE_BREAK_MODES = {
  /** 仅 PC 显示换行：`<br class="powblender_c-small-hide">` */
  PC: 'pc',
  /** 仅移动端显示换行：`<br class="powblender_c-pc-hide">` */
  MOBILE: 'mobile',
  /** 全端普通换行：`<br>` */
  PLAIN: 'plain',
};

/**
 * 拆分模式
 * @readonly
 */
const ADD_BR_SPLIT_MODES = {
  /** 固定 N 行平分 */
  LINES: 'lines',
  /** 按最大字符宽度自动折行 */
  MAX_WIDTH: 'maxWidth',
  /** 按最大宽度算出行数，再平分（兼顾宽度限制与视觉均匀） */
  EVEN_WIDTH: 'evenWidth',
  /**
   * 在硬上限 maxWidth 下贪心分行（不截断 token、不做寡行回拉）。
   * 与 evenWidth 不同：不按总宽/行数先定行数再均分。
   * 注：若用「二分最小 L 且仅要求能装下全文」，在「不拆词」前提下任意 L≥最长词宽都可行，
   * 会退化成 L=最长词宽，行宽远小于 maxWidth；因此本模式固定按 L=maxWidth 贪心。
   */
  EVEN_WIDTH_1: 'evenWidth1',
};

// ─── token 化：把文本拆成不可再断的最小单元 ───

var _tokenizeCache = {};
function createTokenRegex() {
  // 优先使用 Unicode 属性类，覆盖法/德/意/西/希腊/荷兰等语言。
  // 回退分支用于旧 JS 引擎：至少覆盖常见拉丁扩展与希腊字母。
  try {
    return new RegExp(
      '(?:[$€£¥₹]?\\d[\\d,]*\\.?\\d*(?:\\s+[\\p{L}\\p{M}%°℃℉]+\\*?|[\\p{L}\\p{M}%°℃℉]+\\*?)?(?:[，。、；：！？,.;:!?…—–]+)?)|(?:[\\p{L}\\p{M}]+(?:[\\/\'\\-’][\\p{L}\\p{M}]+)*\\*?(?:[，。、；：！？,.;:!?…—–]+)?)|(?:\\s+)|(?:[，。、；：！？,.;:!?…—–·-]+)|(?:[\\s\\S])',
      'gu'
    );
  } catch (e) {
    return new RegExp(
      '(?:[$€£¥₹]?\\d[\\d,]*\\.?\\d*(?:\\s+[A-Za-zÀ-ÖØ-öø-ÿĀ-ſƀ-ɏͰ-Ͽ%°℃℉]+\\*?|[A-Za-zÀ-ÖØ-öø-ÿĀ-ſƀ-ɏͰ-Ͽ%°℃℉]+\\*?)?(?:[，。、；：！？,.;:!?…—–]+)?)|(?:[A-Za-zÀ-ÖØ-öø-ÿĀ-ſƀ-ɏͰ-Ͽ]+(?:[\\/\'\\-’][A-Za-zÀ-ÖØ-öø-ÿĀ-ſƀ-ɏͰ-Ͽ]+)*\\*?(?:[，。、；：！？,.;:!?…—–]+)?)|(?:\\s+)|(?:[，。、；：！？,.;:!?…—–·-]+)|(?:[\\s\\S])',
      'g'
    );
  }
}
var TOKEN_REGEX = createTokenRegex();

function getProtectedPhrases(options) {
  if (!options || !Array.isArray(options.protectedPhrases)) return [];

  return options.protectedPhrases
    .filter(function (item) {
      return item != null && String(item).trim();
    })
    .map(function (item) {
      return String(item);
    })
    .sort(function (a, b) {
      return b.length - a.length;
    });
}

function parseProtectedPattern(item) {
  if (item instanceof RegExp) {
    var flags = item.flags.replace(/g/g, '').replace(/y/g, '');
    return new RegExp(item.source, flags + 'y');
  }

  if (typeof item !== 'string') return null;

  var trimmed = item.trim();
  if (!trimmed) return null;

  var literalMatch = trimmed.match(/^\/(.+)\/([a-z]*)$/i);
  if (literalMatch) {
    var literalFlags = literalMatch[2].replace(/g/g, '').replace(/y/g, '');
    return new RegExp(literalMatch[1], literalFlags + 'y');
  }

  return new RegExp(trimmed, 'y');
}

function getProtectedPatterns(options) {
  if (!options || !Array.isArray(options.protectedPatterns)) return [];

  return options.protectedPatterns
    .map(parseProtectedPattern)
    .filter(function (item) {
      return !!item;
    });
}

function matchProtectedPhraseAt(text, index, protectedPhrases) {
  for (var i = 0; i < protectedPhrases.length; i++) {
    var phrase = protectedPhrases[i];
    if (text.slice(index, index + phrase.length) === phrase) {
      return phrase;
    }
  }
  return '';
}

function matchProtectedPatternAt(text, index, protectedPatterns) {
  var best = '';

  for (var i = 0; i < protectedPatterns.length; i++) {
    protectedPatterns[i].lastIndex = index;
    var match = protectedPatterns[i].exec(text);
    if (!match || !match[0]) continue;
    if (match[0].length > best.length) {
      best = match[0];
    }
  }

  return best;
}

function tokenizeCore(text, options, withOffsets) {
  var protectedPhrases = getProtectedPhrases(options);
  var protectedPatterns = getProtectedPatterns(options);
  var regexFlags = TOKEN_REGEX.unicode ? 'guy' : 'gy';
  var re = new RegExp(TOKEN_REGEX.source, regexFlags);
  var tokens = [];
  var index = 0;

  while (index < text.length) {
    var protectedPhrase = matchProtectedPhraseAt(text, index, protectedPhrases);
    var protectedPattern = matchProtectedPatternAt(text, index, protectedPatterns);
    var protectedText =
      protectedPattern.length > protectedPhrase.length ? protectedPattern : protectedPhrase;

    if (protectedText) {
      if (withOffsets) {
        tokens.push({
          text: protectedText,
          start: index,
          end: index + protectedText.length,
        });
      } else {
        tokens.push(protectedText);
      }
      index += protectedText.length;
      continue;
    }

    re.lastIndex = index;
    var m = re.exec(text);
    if (!m) {
      if (withOffsets) {
        tokens.push({
          text: text.charAt(index),
          start: index,
          end: index + 1,
        });
      } else {
        tokens.push(text.charAt(index));
      }
      index++;
      continue;
    }

    if (withOffsets) {
      tokens.push({
        text: m[0],
        start: m.index,
        end: m.index + m[0].length,
      });
    } else {
      tokens.push(m[0]);
    }
    index += m[0].length;
  }

  return tokens;
}

/**
 * 将文本拆成 token 数组，每个 token 是不应被拆散的最小单元。
 * 规则优先级：
 *  1. 数字+单位 / 数字组合（如 "100ml" "3,000" "1.5kg" "$99"）
 *  2. 连续英文单词（含连字符 / 撇号）
 *  3. 连续标点
 *  4. 连续空白（作为可断点标记）
 *  5. 单个 CJK 字符
 */
function tokenize(text, options) {
  var protectedPhrases = getProtectedPhrases(options);
  if (!protectedPhrases.length && _tokenizeCache[text]) return _tokenizeCache[text];

  var tokens = tokenizeCore(text, options, false);

  if (!protectedPhrases.length && tokens.length < 200) _tokenizeCache[text] = tokens;
  return tokens;
}

function tokenizeWithOffsets(text, options) {
  return tokenizeCore(text, options, true);
}

/** 计算 token 显示宽度（CJK 字符算 2，其余算 1） */
function tokenWidth(tok) {
  var w = 0;
  for (var i = 0; i < tok.length; i++) {
    var code = tok.charCodeAt(i);
    if (
      (code >= 0x4e00 && code <= 0x9fff) ||
      (code >= 0x3400 && code <= 0x4dbf) ||
      (code >= 0xf900 && code <= 0xfaff) ||
      (code >= 0x3000 && code <= 0x303f) ||
      (code >= 0xff00 && code <= 0xffef) ||
      (code >= 0xac00 && code <= 0xd7af)
    ) {
      w += 2;
    } else {
      w += 1;
    }
  }
  return w;
}

/** token 是否为纯空白 */
function isWhitespace(tok) {
  return /^\s+$/.test(tok);
}

/** 纯标点 token 不参与“不寡行”计数 */
function isPunctuationToken(tok) {
  return /^[，。、；：！？,.;:!?…—–\-·]+$/.test(tok);
}

function getOrphanTokenScore(tok) {
  if (isWhitespace(tok)) return 0;
  if (isPunctuationToken(tok)) return 0.5;
  if (/[，。、；：！？,.;:!?…—–]+$/.test(tok) && !isPunctuationToken(tok)) return 1.5;
  return 1;
}

/** 是否为纯 <br>，若是条件 br 隐藏时需要保留原始词间空格 */
function isPlainBrTag(brTag) {
  return brTag === '<br>';
}

function isBrTag(text) {
  return /^<br\b[^>]*\/?>$/i.test(text);
}

function normalizeBrTag(text) {
  return String(text)
    .replace(/\s+/g, ' ')
    .replace(/\s*>/g, '>')
    .trim()
    .toLowerCase();
}

function shouldPreserveBrTag(tag, opts) {
  if (!opts || opts.keepOriginalBr === false) return false;
  var generatedBrTag = resolveBrTag(opts);

  // 重跑时忽略“当前模式本次本来就会生成”的 br，避免把旧计算结果再次当成原始 br 保留。
  if (normalizeBrTag(tag) === normalizeBrTag(generatedBrTag)) {
    return false;
  }

  return true;
}

/** 从 token 数组 [startIdx..endIdx) 合并文本，去掉首尾空白 token */
function joinTokens(tokens, startIdx, endIdx) {
  var s = startIdx;
  var e = endIdx;
  while (s < e && isWhitespace(tokens[s])) s++;
  while (e > s && isWhitespace(tokens[e - 1])) e--;
  var result = '';
  for (var i = s; i < e; i++) result += tokens[i];
  return result;
}

/** 计算 tokens[start..end) 合并后去首尾空白的宽度 */
function rangeWidth(tokens, start, end) {
  var s = start;
  var e = end;
  while (s < e && isWhitespace(tokens[s])) s++;
  while (e > s && isWhitespace(tokens[e - 1])) e--;
  var w = 0;
  for (var i = s; i < e; i++) w += tokenWidth(tokens[i]);
  return w;
}

function hasWhitespaceAtBoundary(tokens, breakIdx) {
  return (
    (breakIdx > 0 && isWhitespace(tokens[breakIdx - 1])) ||
    (breakIdx < tokens.length && isWhitespace(tokens[breakIdx]))
  );
}

function formatLineRanges(tokens, ranges, brTag) {
  var parts = [];

  for (var i = 0; i < ranges.length; i++) {
    parts.push(joinTokens(tokens, ranges[i].s, ranges[i].e));
    if (i >= ranges.length - 1) continue;

    var separator = brTag;
    if (!isPlainBrTag(brTag) && hasWhitespaceAtBoundary(tokens, ranges[i].e)) {
      separator = ' ' + brTag;
    }
    parts.push(separator);
  }

  return parts.join('');
}

function splitWithOriginalBrTags(text) {
  return String(text).split(/(<br\b[^>]*\/?>)/gi);
}

/**
 * 把可能带 HTML 的输入归一化成纯文本，避免已有 <br> / 标签污染分行计算。
 * 这里把 <br> 视为空格，其他标签移除。
 */
function normalizeInputText(text) {
  return String(text)
    .replace(/<br\b[^>]*\/?>/gi, ' ')
    .replace(/<\/p\s*>/gi, ' ')
    .replace(/<\/div\s*>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\s+/g, ' ')
    .replace(/\s+([，。、；：！？,.;:!?…])/g, '$1')
    .trim();
}

function getLeadingAttachedPunctuationLength(text) {
  var match = String(text).match(/^[，。、；：！？,.;:!?…—–]+/);
  return match ? match[0].length : 0;
}

function transformNormalizedText(text, rule, opts) {
  var raw = normalizeInputText(text);
  var mode = opts.mode || ADD_BR_SPLIT_MODES.LINES;
  var brTag = resolveBrTag(opts);
  var tokens = tokenize(raw, opts);

  if (tokens.length <= 1) return raw;

  var lines;

  if (mode === ADD_BR_SPLIT_MODES.EVEN_WIDTH && opts.maxWidth > 0) {
    lines = splitByEvenWidth(tokens, opts.maxWidth);
  } else if (mode === ADD_BR_SPLIT_MODES.EVEN_WIDTH_1 && opts.maxWidth > 0) {
    lines = splitByEvenWidth1(tokens, opts.maxWidth);
  } else if (mode === ADD_BR_SPLIT_MODES.MAX_WIDTH && opts.maxWidth > 0) {
    lines = splitByMaxWidth(tokens, opts.maxWidth, opts.minOrphan, opts.disableOrphanControl);
  } else {
    var n = Math.max(1, Math.floor(Number(rule)) || 1);
    if (n <= 1) return raw;
    lines = splitByLines(tokens, n);
  }

  if (!lines || lines.length <= 1) return raw;
  return formatLineRanges(tokens, lines, brTag);
}

function extractOriginalBrAnchors(text, opts) {
  var parts = splitWithOriginalBrTags(text);
  var plainText = '';
  var anchors = [];
  var pendingBrTags = [];
  var pendingDroppedBr = false;

  for (var i = 0; i < parts.length; i++) {
    var part = parts[i];
    if (!part) continue;

    if (isBrTag(part)) {
      if (shouldPreserveBrTag(part, opts)) {
        pendingBrTags.push(part);
      } else {
        pendingDroppedBr = true;
      }
      continue;
    }

    var normalized = normalizeInputText(part);
    if (!normalized) {
      continue;
    }

    var leadingPunctuationLength = getLeadingAttachedPunctuationLength(normalized);

    if (plainText && (pendingBrTags.length || pendingDroppedBr) && leadingPunctuationLength === 0) {
      plainText += ' ';
    }

    if (pendingBrTags.length) {
      var anchorOffset = plainText.length + leadingPunctuationLength;
      for (var j = 0; j < pendingBrTags.length; j++) {
        anchors.push({
          offset: anchorOffset,
          tag: pendingBrTags[j],
        });
      }
      pendingBrTags = [];
    }
    pendingDroppedBr = false;

    plainText += normalized;
  }

  if (pendingBrTags.length) {
    var endOffset = plainText.length;
    for (var k = 0; k < pendingBrTags.length; k++) {
      anchors.push({
        offset: endOffset,
        tag: pendingBrTags[k],
      });
    }
  }

  return {
    plainText: plainText,
    anchors: anchors,
  };
}

function restoreOriginalBrs(text, rule, opts) {
  var model = extractOriginalBrAnchors(text, opts);
  var transformed = transformNormalizedText(model.plainText, rule, opts);

  if (!model.anchors.length) return transformed;

  var result = '';
  var plainOffset = 0;
  var anchorIndex = 0;
  var pos = 0;

  while (pos < transformed.length) {
    while (
      anchorIndex < model.anchors.length &&
      model.anchors[anchorIndex].offset === plainOffset
    ) {
      result += model.anchors[anchorIndex].tag;
      anchorIndex++;
    }

    if (transformed.slice(pos, pos + 3).toLowerCase() === '<br') {
      var end = transformed.indexOf('>', pos);
      if (end === -1) {
        result += transformed.slice(pos);
        pos = transformed.length;
        break;
      }
      result += transformed.slice(pos, end + 1);
      pos = end + 1;
      continue;
    }

    result += transformed.charAt(pos);
    plainOffset++;
    pos++;
  }

  while (
    anchorIndex < model.anchors.length &&
    model.anchors[anchorIndex].offset === plainOffset
  ) {
    result += model.anchors[anchorIndex].tag;
    anchorIndex++;
  }

  return result;
}

// ─── 模式一：固定 N 行平分 ───

function splitByLines(tokens, lineCount) {
  var totalW = 0;
  for (var i = 0; i < tokens.length; i++) totalW += tokenWidth(tokens[i]);

  var idealLineW = totalW / lineCount;
  var ranges = [];
  var lineStart = 0;
  var accW = 0;

  for (var li = 0; li < lineCount - 1; li++) {
    var target = idealLineW * (li + 1);
    var bestIdx = lineStart;
    var bestDiff = Infinity;

    for (var ti = lineStart; ti < tokens.length; ti++) {
      accW += tokenWidth(tokens[ti]);
      if (isWhitespace(tokens[ti])) continue;

      var diff = Math.abs(accW - target);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestIdx = ti + 1;
      }
      if (accW > target + idealLineW * 0.3) break;
    }

    if (bestIdx <= lineStart) bestIdx = lineStart + 1;
    if (bestIdx >= tokens.length) break;

    ranges.push({ s: lineStart, e: bestIdx });
    lineStart = bestIdx;
    accW = 0;
    for (var ri = 0; ri < lineStart; ri++) accW += tokenWidth(tokens[ri]);
  }

  if (lineStart < tokens.length) {
    ranges.push({ s: lineStart, e: tokens.length });
  }

  return ranges;
}

// ─── 模式二：最大宽度折行 + 防寡行 ───

function splitByMaxWidth(tokens, maxWidth, minOrphan, disableOrphanControl) {
  var orphanControlOff = disableOrphanControl === true;
  var orphanMin = minOrphan != null ? minOrphan : 2;
  var lines = [];
  var lineStart = 0;
  var lineW = 0;

  for (var ti = 0; ti < tokens.length; ti++) {
    var tw = tokenWidth(tokens[ti]);

    if (lineW > 0 && lineW + tw > maxWidth) {
      lines.push({ s: lineStart, e: ti });
      lineStart = ti;
      while (lineStart < tokens.length && isWhitespace(tokens[lineStart])) {
        lineStart++;
        ti = lineStart;
      }
      lineW = 0;
      // ti 可能在 while 中被前移；须按新 ti 重算 tw，否则会误用触发断行时的旧宽度
      if (ti >= tokens.length) {
        continue;
      }
      tw = tokenWidth(tokens[ti]);
    }

    if (isWhitespace(tokens[ti]) && lineW === 0) {
      lineStart = ti + 1;
      continue;
    }
    lineW += tw;
  }
  if (lineStart < tokens.length) {
    lines.push({ s: lineStart, e: tokens.length });
  }

  if (orphanControlOff || lines.length < 2) {
    return lines;
  }

  var last = lines[lines.length - 1];
  var lastScore = 0;
  for (var ci = last.s; ci < last.e; ci++) {
    lastScore += getOrphanTokenScore(tokens[ci]);
  }

  if (lastScore > 0 && lastScore < orphanMin && lines.length >= 2) {
    var prev = lines[lines.length - 2];
    // 仅从上一行末尾借「一个」词（一个非空白 token），且借词后末行总宽仍不超过 maxWidth
    var cut = prev.e;
    while (cut > prev.s && isWhitespace(tokens[cut - 1])) {
      cut--;
    }
    if (cut > prev.s) {
      var wordStart = cut - 1;
      var mergedW = rangeWidth(tokens, wordStart, last.e);
      if (mergedW <= maxWidth) {
        lines[lines.length - 2] = { s: prev.s, e: wordStart };
        lines[lines.length - 1] = { s: wordStart, e: last.e };
      }
    }
  }

  return lines;
}

// ─── 模式三：按最大宽度算行数，再平分 ───

function splitByEvenWidth(tokens, maxWidth) {
  var totalW = rangeWidth(tokens, 0, tokens.length);
  var lineCount = Math.max(1, Math.ceil(totalW / maxWidth));
  if (lineCount <= 1) return null;
  return splitByLines(tokens, lineCount);
}

// ─── 模式四：硬上限 maxWidth + 贪心分行（evenWidth1）───

function maxNonWhitespaceTokenWidth(tokens) {
  var m = 0;
  for (var i = 0; i < tokens.length; i++) {
    if (isWhitespace(tokens[i])) continue;
    var w = tokenWidth(tokens[i]);
    if (w > m) m = w;
  }
  return m;
}

/**
 * 每行宽度（trim 首尾空白后）不超过 L 时贪心分行；不可行（含单个 token 宽 > L）返回 null。
 * 逻辑与 splitByMaxWidth 一致，但不做寡行回拉。
 */
function greedySplitByMaxLineWidth(tokens, L) {
  var lines = [];
  var lineStart = 0;
  var lineW = 0;

  for (var ti = 0; ti < tokens.length; ti++) {
    var tw = tokenWidth(tokens[ti]);

    if (!isWhitespace(tokens[ti]) && tw > L) {
      return null;
    }

    if (lineW > 0 && lineW + tw > L) {
      lines.push({ s: lineStart, e: ti });
      lineStart = ti;
      while (lineStart < tokens.length && isWhitespace(tokens[lineStart])) {
        lineStart++;
        ti = lineStart;
      }
      lineW = 0;
      if (ti >= tokens.length) {
        continue;
      }
      tw = tokenWidth(tokens[ti]);
    }

    if (isWhitespace(tokens[ti]) && lineW === 0) {
      lineStart = ti + 1;
      continue;
    }
    lineW += tw;
  }
  if (lineStart < tokens.length) {
    lines.push({ s: lineStart, e: tokens.length });
  }

  return lines;
}

function splitByEvenWidth1(tokens, maxWidth) {
  var minWordW = maxNonWhitespaceTokenWidth(tokens);
  if (minWordW > maxWidth) {
    return splitByMaxWidth(tokens, maxWidth, null, true);
  }

  return greedySplitByMaxLineWidth(tokens, maxWidth);
}

// ─── 主入口 ───

/**
 * 按多种模式为纯文本插入 `<br>` 换行标签。
 *
 * @param {string} text - 原始文本
 * @param {number|string} rule
 *   - 数字 → 固定行数模式（兼容旧版 addBrForText(text, 3)）
 *   - 不传 / 无效 → 返回原文
 * @param {{
 *   mode?: 'lines' | 'maxWidth' | 'evenWidth' | 'evenWidth1',
 *   maxWidth?: number,
 *   minOrphan?: number,
 *   preferBreakChars?: string,
 *   lineBreakMode?: 'pc' | 'mobile' | 'plain',
 *   lineBreakFor?: 'pc' | 'mobile' | 'mb',
 *   brClass?: string
 * }} [options]
 *
 * @example
 * // 模式一：固定 3 行平分（兼容旧调用）
 * addBrForText("some long text here", 3)
 * addBrForText("some long text here", 3, { mode: 'lines' })
 *
 * @example
 * // 模式二：每行最多 20 字符宽度（顺排折行）
 * addBrForText("some long text", 0, { mode: 'maxWidth', maxWidth: 20 })
 *
 * @example
 * // 模式三：每行最多 20 宽度，但各行平分均匀
 * addBrForText("some long text", 0, { mode: 'evenWidth', maxWidth: 20 })
 *
 * @example
 * // 模式四：每行不超过 maxWidth，贪心分行（无寡行回拉）
 * addBrForText("some long text", 0, { mode: 'evenWidth1', maxWidth: 20 })
 *
 * @returns {string} 插入 <br> 后的 HTML 片段
 */
function addBrForText(text, rule, options) {
  if (text == null || text === '') return '';
  var opts = options || {};
  var source = String(text);
  var keepOriginalBr = opts.keepOriginalBr !== false;

  if (keepOriginalBr && /<br\b[^>]*\/?>/i.test(source)) {
    return restoreOriginalBrs(source, rule, opts);
  }

  return transformNormalizedText(source, rule, opts);
}

// ─── br 标签解析（保持原逻辑） ───

/**
 * @param {{
 *   lineBreakMode?: string,
 *   lineBreakFor?: string,
 *   brClass?: string
 * }} [options]
 * @returns {string} 完整 <br> 标签
 */
function resolveBrTag(options) {
  if (options && typeof options.brClass === 'string') {
    var c = options.brClass.trim();
    if (c) {
      return '<br class="' + c.replace(/"/g, '&quot;') + '">';
    }
  }

  var rawMode =
    (options && options.lineBreakMode) ||
    (options && options.lineBreakFor) ||
    ADD_BR_LINE_BREAK_MODES.PC;

  var mode = rawMode === 'mb' ? ADD_BR_LINE_BREAK_MODES.MOBILE : rawMode;

  if (mode === ADD_BR_LINE_BREAK_MODES.PLAIN || mode === 'plain') {
    return '<br>';
  }
  if (mode === ADD_BR_LINE_BREAK_MODES.MOBILE || mode === 'mobile') {
    return '<br class="powblender_c-pc-hide">';
  }
  return '<br class="powblender_c-small-hide">';
}

// ─── 导出 ───

if (typeof window !== 'undefined') {
  window.addBrForText = addBrForText;
  window.ADD_BR_LINE_BREAK_MODES = ADD_BR_LINE_BREAK_MODES;
  window.ADD_BR_SPLIT_MODES = ADD_BR_SPLIT_MODES;
  window.tokenize = tokenize;
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    addBrForText,
    resolveBrTag,
    tokenize,
    tokenWidth,
    ADD_BR_LINE_BREAK_MODES,
    ADD_BR_SPLIT_MODES,
  };
}
